<template>
  <div class="padding-max">
    <v-card class="mx-auto pb-5" outlined>
      <v-toolbar color="#27e96a" flat>
        <v-toolbar-title>
          <span class="text-complementary-color">Crear nueva etiqueta</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-container fluid>
        <v-form lazy-validation v-model="validForm" class="padding-max">
          <v-row class="justify-start" wrap>
            <v-col sm="12" md="8" lg="6">
              <v-text-field
                v-model="filename"
                label="Nombre de la Etiqueta"
                required
                color="#27e96a"
              >
              </v-text-field>
            </v-col>
            <v-col sm="12" md="8" lg="5">
              <v-text-field
                v-model="filenameFormat"
                label="Formato de la Etiqueta"
                required
                color="#27e96a"
              >
              </v-text-field>
            </v-col>
            <v-col sm="12" md="8" lg="1" class="pt-8">
              <v-btn icon @click="isActiveModal = true">
                <v-icon medium v-on="on">mdi-help-circle</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <div style="bottom: 5px;">
        <v-btn
          :disabled="isValid"
          @click="savedFilenameFormat"
          class="ml-5 button-tertiary"
          :loading="saving"
          >Guardar</v-btn
        >
      </div>
      <v-alert
        style="margin-top: 20px;"
        v-model="showError"
        dismissible="true"
        icon="mdi-alert-circle-outline"
        prominent
        text
        type="error"
      >
        {{ textError }}
      </v-alert>
    </v-card>
    <helpModal
      class="alignTablaSobreFondo ml-5 mr-5"
      :isActiveModal="isActiveModal"
      @close="isActiveModal = false"
    />
  </div>
</template>
<script>
import { httpByCurrentCustomer, downloadFromBlob } from "../../lib/client";
import helpModal from "./helpModal";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";

export default Vue.extend({
  components: {
    helpModal,
  },
  data() {
    return {
      filename: "",
      filenameFormat: "",
      showError: false,
      isActiveModal: false,
    };
  },
  props: {},
  created() {
    this.$store.dispatch("filenameFormat/getFilenameFormat");
  },
  computed: {
    isValid() {
      if (this.filename != "" && this.filenameFormat != "") {
        return false;
      }
      return true;
    },
    ...mapGetters("filenameFormat", {
      listFilenameFormat: "filenameFormatTable",
    }), // Traemos los valores
  },
  methods: {
    async savedFilenameFormat() {
      const json = {
        name: this.filename,
        format: this.filenameFormat,
      };
      try {
        this.verificationFilenameFormat();
        this.verifyExistence();
        await this.$store.dispatch("filenameFormat/createFilenameFormat", json);
        this.$router.push("/filenameformat");
      } catch (error) {
        this.showMessageError(error);
      }
    },
    verifyExistence() {
      const search = this.listFilenameFormat.filter(
        (r) =>
          r.filename_format === this.filenameFormat || r.name === this.filename
      );
      if (search.length > 0) {
        throw "El nombre de su formato ya se encuentra en uso.";
      }
    },
    verificationFilenameFormat() {
      //TODO Mejorar este metodo. Proximo PR
      if (
        this.filenameFormat.indexOf("{") === -1 &&
        this.filenameFormat.indexOf("}") === -1
      ) {
        throw "El formato debe contener llaves.";
      }
      const rest = this.filenameFormat.substr(this.filenameFormat.length - 4);
      if (this.filenameFormat.split(".")[1] != "mp3") {
        throw "El formato debe ser mp3.";
      }
    },
    showMessageError(message) {
      this.textError = message;
      this.showError = true;
    },
  },
});
</script>

<style></style>
